import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import DinBilpartnerBadge from '../components/DinBilpartnerBadge'
import ReviewsSlider from '../components/ReviewsSlider'
import { imageUrl } from '../lib/images'

const TEAM_MEMBERS = [
  {
    name: 'Steen Ek',
    role: 'Indehaver/Sælger',
    phone: '22 18 73 30',
    email: 'steen@ekbiler.dk',
    image: imageUrl('repair.png', 'width=300,quality=85,format=auto'),
    bio: 'Indehaver af EK Biler, og tager sig af salg og indkøb af biler og har gjort det siden 2011, så mange års erfaring inden for faget.',
  },
  {
    name: 'Lars Lund',
    role: 'Auto Mekaniker/Tekniker',
    phone: '22 18 73 30',
    email: 'lars@ekbiler.dk',
    image: imageUrl('img-9496-scaled.jpeg', 'width=600,quality=85,format=auto'),
    bio: 'Uddannet mekaniker/tekniker og har mange års erfaring med Tyske bilmærker. Lars har bestået div. kursus. Han har tidligere været ved Autoriseret VW værksted i mange år og er knivskarp til fejlsøgning på biler.',
  },
  {
    name: 'Jørgen Skov Hansen',
    role: 'Automekaniker & Pladesmed',
    phone: '22 18 73 30',
    email: 'steen@ekbiler.dk',
    image: imageUrl('img-6840-scaled.jpeg', 'width=600,quality=85,format=auto'),
    bio: 'Uddannet mekaniker med mange års erfaring i alle bilmærker med Speciale i VW. Jørgen er også vores pladesmed i skadeafdelingen og super omhyggelig i div. opgaver dagen bringer.',
  },
  {
    name: 'Artem Silkin',
    role: 'Klargøring / Mekaniker / Blæksprutte',
    phone: '22 18 73 30',
    email: 'steen@ekbiler.dk',
    image: imageUrl('img-6846-1-scaled.jpeg', 'width=600,quality=85,format=auto'),
    bio: 'Vores klargøringsmand/mekaniker/blæksprutte, meget omhyggelig person, med styr på tingene, der er ikke en opgave som ikke kan løses…',
  },
  {
    name: 'Mathias Krusborg Ingebrigtsen',
    role: 'Mekaniker Lærling',
    phone: '22 18 73 30',
    email: 'steen@ekbiler.dk',
    image: imageUrl('repair.png', 'width=300,quality=85,format=auto'),
    bio: '1 års lærling ved os, og kan allerede udføre mange opgaver.',
  },
  {
    name: 'Gustav Holm',
    role: 'Arbejdsdreng',
    phone: '22 18 73 30',
    email: 'steen@ekbiler.dk',
    image: imageUrl('repair.png', 'width=300,quality=85,format=auto'),
    bio: 'Vores ungarbejder, som står for rengøring af værksted og div oprydningsopgaver ugen bringer.',
  },
]

export default function OmOsPage({ settings }) {
  const phone = settings?.phone || '22 18 73 30'
  const phoneRaw = settings?.phone_raw || '22187330'
  const bookingUrl = settings?.booking_url || 'https://service.dinbilpartner.dk/book-tid'

  return (
    <>
      <MetaTags
        title="Om os | EK Biler v/Steen Svensson Ek"
        description="EK Biler er et bilfirma, som handler med gode, brugte kvalitetsbiler i forskellige størrelser, og driver professionelt autoværksted i Hejnsvig."
        ogTitle="Om os | EK Biler v/Steen Svensson Ek"
        ogDescription="EK Biler er et bilfirma, som handler med gode, brugte kvalitetsbiler i forskellige størrelser, og driver professionelt autoværksted i Hejnsvig."
        ogImage={imageUrl('ek-biler6.jpg', 'width=1200,quality=85,format=auto')}
      />

      {/* Hero */}
      <section className="bg-[#14171a] text-white py-14 sm:py-20 border-b border-[#262c33] relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src={imageUrl('ek-biler6.jpg', 'width=1600,quality=80,format=auto')}
            alt="EK Biler virksomheden"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-4">
            <div className="flex items-center gap-2 text-xs font-bold text-gray-400 uppercase tracking-wider">
              <Link to="/" className="hover:text-white">Forside</Link>
              <span>/</span>
              <span className="text-[#e20019]">Virksomheden</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Om os
            </h1>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              I veludstyrede lokaler på Mejerivej 12, 7250 Hejnsvig finder man EK Biler. Her arbejder
              Lars, Jørgen, Artem, Gustav og Steen hver dag, for at få glade kunder og deres biler
              hurtigt videre.
            </p>
            <div className="pt-2 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white px-6 py-3 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap text-center"
              >
                <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                <span>Book tid på værkstedet</span>
              </a>
              <a
                href={`tel:${phoneRaw}`}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#20252c] hover:bg-[#2b323c] border border-gray-700 text-white px-5 py-3 rounded-xl font-bold text-sm transition-colors whitespace-nowrap text-center"
              >
                <i className="fa-solid fa-phone text-[#e20019]" aria-hidden="true" />
                <span>Ring på {phone}</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Story & Values from Scrape */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6 text-gray-800 leading-relaxed text-base">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
                Om EK Biler
              </h2>
              <p>
                I veludstyrede lokaler på Mejerivej 12, 7250 Hejnsvig finder man <strong>EK Biler</strong>.
                Her arbejder Lars, Jørgen, Artem, Gustav og Steen hver dag, for at få glade kunder og
                deres biler hurtigt videre.
              </p>
              <p>
                Men det er ikke fart for enhver pris. Vi arbejder altid ud fra Den Høje Standard – en
                række sunde principper, som sikrer dig kompetent rådgivning og håndværk til en fair pris.
              </p>

              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200 mt-6">
                <h3 className="font-bold text-gray-900 text-lg mb-3">Din Bilpartner siden 2023</h3>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-center gap-2.5">
                    <i className="fa-solid fa-check text-[#e20019]" aria-hidden="true" />
                    <span>Professionel service og reparation og skader af alle bilmærker</span>
                  </li>
                  <li className="flex items-center gap-2.5">
                    <i className="fa-solid fa-check text-[#e20019]" aria-hidden="true" />
                    <span>Speciale i V.A.G Gruppen (VW – Audi – Seat – Skoda)</span>
                  </li>
                  <li className="flex items-center gap-2.5">
                    <i className="fa-solid fa-check text-[#e20019]" aria-hidden="true" />
                    <span>Altid mulighed for lånebil, når din bil er på værksted</span>
                  </li>
                  <li className="flex items-center gap-2.5">
                    <i className="fa-solid fa-check text-[#e20019]" aria-hidden="true" />
                    <span>Express fordelskoncept</span>
                  </li>
                  <li className="flex items-center gap-2.5">
                    <i className="fa-solid fa-check text-[#e20019]" aria-hidden="true" />
                    <span>Bilsalg – find din nye bedre brugte bil hos os</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-md">
                <img
                  src={imageUrl('ek-biler6.jpg', 'width=800,quality=85,format=auto')}
                  alt="EK Biler i Hejnsvig"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="py-16 bg-gray-50 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">
              Vores medarbejdere
            </h2>
            <p className="text-gray-600 text-sm mt-2">
              Mød holdet bag EK Biler. Vi står klar til at hjælpe dig på Mejerivej 12 i Hejnsvig.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {TEAM_MEMBERS.map((member) => (
              <div
                key={member.name}
                className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm flex flex-col justify-between hover:shadow-md transition-shadow"
              >
                <div>
                  <div className="aspect-[4/3] bg-gray-100 overflow-hidden relative border-b border-gray-100 flex items-center justify-center">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900">{member.name}</h3>
                    <div className="text-xs font-bold text-[#e20019] uppercase tracking-wider mt-1 mb-3">
                      {member.role}
                    </div>
                    <p className="text-sm text-gray-600 leading-relaxed">{member.bio}</p>
                  </div>
                </div>

                <div className="p-6 pt-0 border-t border-gray-100 mt-4 space-y-1.5 text-xs text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="fa-solid fa-phone text-[#e20019]" aria-hidden="true" />
                    <a
                      href={`tel:${member.phone.replace(/\s+/g, '')}`}
                      className="font-bold text-gray-800 hover:text-[#e20019] transition-colors whitespace-nowrap"
                    >
                      {member.phone}
                    </a>
                  </div>
                  {member.email && (
                    <div className="flex items-center gap-2">
                      <i className="fa-solid fa-envelope text-gray-400" aria-hidden="true" />
                      <a
                        href={`mailto:${member.email}`}
                        className="text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap"
                      >
                        {member.email}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <DinBilpartnerBadge />
      <ReviewsSlider />
    </>
  )
}
